
export default {
  name: 'Menu',

  computed: {
    menuList: function () {
      let items = this.$store.state?.cms?.menus?.default?.items || [];
      items = items.filter((t) => !t.isHidden);
      items = items.map((item) => ({
        ...item,
        children: (item?.children || []).filter((t) => !t.isHidden),
      }));

      return items;
    },
  },

  components: {
    MenuItem: () => import('./_MenuItem'),
  },
};
